/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const red = {
    50: '#FBECEB',
    100: '#FFD1C8',
    200: '#FFB4AF',
    300: '#FF8A82',
    400: '#E9594F',
    500: '#E33E38',
    600: '#C42E23',
    700: '#B12319',
    800: '#911A12',
    900: '#6F0F08',
    1000: '#4D0601',
};
